export const DEFAULT_CROPPER_CONFIG: { [key: string]: any } = {
  aspectRatio: 1,
  background: true,
  center: true,
  checkImageOrigin: true,
  cropBoxResizable: true,
  dragMode: 'move',
  minCropBoxHeight: 64,
  minCropBoxWidth: 64,
  movable: true,
  responsive: true,
  rotatable: true,
  scalable: true,
  viewMode: 1,
  zoomable: true
};

export const WIDE_SIZE_CROPPER_CONFIG: { [key: string]: any } = {
  ...DEFAULT_CROPPER_CONFIG,
  aspectRatio: 16 / 9
};
